"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenRequestOption = void 0;
var TokenRequestOption;
(function (TokenRequestOption) {
    TokenRequestOption["ORG_KEY"] = "orgkey";
    TokenRequestOption["TPL_GUID"] = "tplguid";
    TokenRequestOption["WM_ID"] = "warehousemanagaercustomerid";
    TokenRequestOption["IM_ID"] = "integrationmanageraccountid";
    TokenRequestOption["OM_ID"] = "ordermanagercompanyid";
})(TokenRequestOption = exports.TokenRequestOption || (exports.TokenRequestOption = {}));
